
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">
                {{ $t("monthly_allowance") }}
            </li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
                <i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
            </button>
        </div>
        <div class="x_body">
            <div class="card x_card no-bor">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList">
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm no-bor" style="overflow-x: scroll">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 50px">{{ $t("no") }}</th>
                                <th>{{ $t("code") }}</th>
                                <th>{{ $t("name") }}</th>
                                <th class="text-right">{{ $t("amount") }}</th>
                                <th style="width: 65px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(ret, index) in records">
                                <tr :key="index" class="bg-default">
                                    <td colspan="4">{{ret.Employee.Num}} - {{ret.Employee.KhmerName}}</td>
                                    <td>
                                        <a href="javascript:void(0)" class="btn btn-success btn-xs" @click="onAddNew(ret.Employee)"><i class="fa fa-plus" aria-hidden="true"></i></a>
                                    </td>
                                </tr>
                                <tr v-for="(item,sindex) in ret.EmployeeAllowances" :key="(sindex + '-'+ index)">
                                    <td class="text-center">{{sindex+1}}</td>
                                    <td>{{item.Allowance.Code}}</td>
                                    <td>{{item.Allowance.Name}}</td>
                                    <td class="text-right">{{$dollar(item.EmployeeAllowance.Amount)}}</td>
                                    <td>
                                        <a href="javascript:void(0)" class="btn btn-warning btn-xs" @click="onEdit(ret.Employee, item)"><i class="fa fa-pencil" aria-hidden="true"></i></a><span style="display: inline-block; width: 3px;"> </span>
                                        <a href="javascript:void(0)" class="btn btn-danger btn-xs" @click="onDelete(item.EmployeeAllowance.Id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <b-modal :no-close-on-backdrop="true" :title="$t('monthly_allowance')" size="md" ref="innermodal">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <div class="form-control form-control-sm">{{model.Num}} - {{model.Name}}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-9">
                    <div class="form-group" :class="{ 'form-group-error': $v.model.AllowanceId.$error }">
                        <label class="label-control blue">{{$t("allowance")}}</label>
                        <div>
                            <select class="form-control form-control-sm" v-model="model.AllowanceId">
                                <option v-for="ret in allowances" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group" :class="{ 'form-group-error': $v.model.Amount.$error }">
                        <label class="label-control blue">{{$t("amount")}}</label>
                        <div>
                            <input type="number" class="form-control form-control-sm" v-model="model.Amount" />
                        </div>
                    </div>
                </div>
            </div>
            <div slot="modal-footer">
                <b-btn variant="primary" size="sm" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{ $t("save") }}</b-btn>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import { required } from "vuelidate/lib/validators";
export default {
    data: function () {
        return {
            query: {
                Text: ''
            },
            records: [],
            model: {
                EmployeeId: '',
                AllowanceId: '',
                Num: '',
                Name: '',
                Amount: 0
            },
            allowances: []
        }
    },
    validations: {
        model: {
            Amount: { required },
            AllowanceId: { required }
        },
    },
    created: function () {
        this.allowanceList();
        this.toList();
    },
    methods: {
        toList: function () {
            let loading = this.$loading.show();
            this.$api().post("employee/allowances", this.query).then((res) => {
                if (this.$isValid(res)) {
                    this.records = res.data.Json.EmployeeAllowances;
                }
            }).finally(function () { loading.hide(); });
        },
        allowanceList: async function(){
            var res = await this.$api().post("allowances");
            if (this.$isValid(res)) {
                this.allowances = res.data.Json.Allowances;
            }
        },
        onAddNew: function (employee) {
            this.model.EmployeeId = employee.Id;
            this.model.Num = employee.Num;
            this.model.Name = employee.KhmerName;
            this.model.AllowanceId = '';
            this.model.Amount = '';
            this.$v.$reset();
            this.$refs.innermodal.show();
        },
        onSave: function () {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let loading = this.$loading.show();
                this.$api().post("employee/allowance", this.model).then((res) => {
                    if (this.$isValid(res)) {
                        this.$refs.innermodal.hide();
                        this.toList();
                    }
                }).finally(function () { loading.hide(); });
            }
        },
        onEdit: function(employee, item){
            this.model = JSON.parse(JSON.stringify(item.EmployeeAllowance));
            this.model.EmployeeId = employee.Id;
            this.model.Num = employee.Num;
            this.model.Name = employee.KhmerName;
            this.$v.$reset();
            this.$refs.innermodal.show();
        },
        onDelete: function(id){
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                if (result.value) {
                    this.$api().post('employee/allowance/delete', { Id: id }).then(res=>{
                        if(this.$isValid(res)){
                            this.toList();
                        }
                    });
                }
            });
        }
    },
};
</script>
<style scoped>
    .bg-default{
        background: #f2f2f2;
    }
    .btn-xs{
        padding: 3px 5px;
        color: #fff !important;
        border-radius: 3px;
        line-height: 0;
        cursor: pointer;
    }
</style>